import { render, staticRenderFns } from "./divedeTournament.vue?vue&type=template&id=7f0fbae6"
import script from "./divedeTournament.vue?vue&type=script&lang=js"
export * from "./divedeTournament.vue?vue&type=script&lang=js"
import style0 from "./divedeTournament.vue?vue&type=style&index=0&id=7f0fbae6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports